export const TOAST_TYPE_DEFAULT = 'default'
export const TOAST_TYPE_SUCCESS = 'success'
export const TOAST_TYPE_ERROR = 'error'

export const TOAST_TYPES = [
  TOAST_TYPE_DEFAULT,
  TOAST_TYPE_SUCCESS,
  TOAST_TYPE_ERROR
]

export type ToastTypes = typeof TOAST_TYPES[number]
